export interface Category {
  id: number;
  name: string;
  nameIt: string;
  url: string;
  imageUrl: string;
  isPopular: boolean;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    nameIt: 'Scarpe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20sneakers%20collection%20displayed%20on%20warm%20terracotta%20ceramic%20surface%2C%20soft%20natural%20window%20light%20from%20left%2C%20minimalist%20composition%20with%20trailing%20ivy%20leaves%20at%20edge%2C%20warm%20terracotta%20and%20sage%20green%20accents%2C%20editorial%20fashion%20photography%20with%20rich%20shadows%20and%20organic%20textures&width=800&height=600&seq=cat-shoes-v2&orientation=landscape',
    isPopular: true,
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    nameIt: 'Felpe/Maglioni',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20knit%20sweaters%20cascading%20over%20a%20rustic%20wooden%20bench%20in%20afternoon%20sunlight%2C%20forest%20green%20and%20oatmeal%20color%20palette%2C%20dappled%20light%20through%20leaves%2C%20cozy%20fashion%20editorial%20photography%20with%20organic%20outdoor%20setting%2C%20soft%20bokeh%20background&width=800&height=600&seq=cat-hoodies-v2&orientation=landscape',
    isPopular: true,
  },
  {
    id: 3,
    name: 'T-Shirts',
    nameIt: 'T-Shirt',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirts%20in%20pastel%20shades%20hanging%20on%20a%20bamboo%20rack%20against%20a%20sunlit%20whitewashed%20brick%20wall%2C%20gentle%20morning%20light%20casting%20soft%20shadows%2C%20mediterranean%20terrace%20aesthetic%2C%20clean%20and%20airy%20fashion%20photography%20with%20hints%20of%20lavender&width=800&height=600&seq=cat-tshirts-v2&orientation=landscape',
    isPopular: true,
  },
  {
    id: 4,
    name: 'Jackets',
    nameIt: 'Giacche',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Leather%20and%20denim%20jackets%20styled%20on%20mannequin%20busts%20against%20an%20industrial%20loft%20wall%20with%20exposed%20brick%2C%20dramatic%20side%20lighting%20creating%20deep%20contrast%2C%20urban%20fashion%20editorial%2C%20warm%20amber%20and%20charcoal%20tones%2C%20gritty%20yet%20sophisticated%20composition&width=800&height=600&seq=cat-jackets-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    nameIt: 'Pantaloni/Corti',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20neatly%20folded%20on%20a%20vintage%20rattan%20chair%20on%20a%20sun-drenched%20balcony%20overlooking%20the%20sea%2C%20soft%20breeze%20suggestion%2C%20amalfi%20coast%20aesthetic%2C%20warm%20golden%20hour%20light%2C%20relaxed%20luxury%20fashion%20photography%20with%20mediterranean%20vibes&width=800&height=600&seq=cat-pants-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 6,
    name: 'Headwear',
    nameIt: 'Copricapi',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20berets%20arranged%20on%20a%20marble%20shelf%20with%20a%20round%20mirror%20backdrop%2C%20soft%20diffused%20studio%20light%2C%20boutique%20interior%20aesthetic%2C%20blush%20pink%20and%20ivory%20color%20palette%2C%20sophisticated%20accessories%20photography%20with%20elegant%20reflections&width=800&height=600&seq=cat-headwear-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 7,
    name: 'Sets',
    nameIt: 'Set',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20lounge%20sets%20displayed%20on%20a%20plush%20velvet%20ottoman%20in%20a%20sunlit%20reading%20nook%2C%20warm%20caramel%20and%20dusty%20rose%20tones%2C%20soft%20textured%20fabrics%2C%20hygge%20inspired%20fashion%20still%20life%2C%20gentle%20afternoon%20light%20through%20sheer%20curtains%2C%20cozy%20editorial%20photography&width=800&height=600&seq=cat-sets-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    nameIt: 'Intimo',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organic%20cotton%20underwear%20delicately%20arranged%20on%20a%20smooth%20river%20stone%20surface%20with%20fresh%20eucalyptus%20sprigs%2C%20soft%20natural%20light%2C%20spa%20like%20serene%20aesthetic%2C%20sage%20green%20and%20sand%20tones%2C%20clean%20minimalist%20product%20photography%20with%20zen%20atmosphere&width=800&height=600&seq=cat-underwear-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 9,
    name: 'Jersey',
    nameIt: 'Maglie Sportive',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Performance%20athletic%20jerseys%20dynamically%20draped%20on%20stadium%20seats%20under%20floodlights%2C%20vibrant%20team%20colors%20contrasting%20with%20dark%20background%2C%20sport%20photography%20aesthetic%2C%20sense%20of%20motion%20and%20energy%2C%20dramatic%20lighting%20with%20lens%20flare%2C%20professional%20sportswear%20editorial&width=800&height=600&seq=cat-jersey-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 10,
    name: 'Accessories',
    nameIt: 'Accessori',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20watches%20and%20bracelets%20artistically%20scattered%20on%20a%20polished%20walnut%20tabletop%20with%20scattered%20rose%20petals%2C%20candlelit%20ambient%20glow%2C%20luxury%20jewelry%20photography%2C%20deep%20burgundy%20and%20gold%20accents%2C%20romantic%20evening%20aesthetic%20with%20rich%20bokeh%20highlights&width=800&height=600&seq=cat-accessories-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 11,
    name: 'Bags',
    nameIt: 'Borse',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20handbags%20displayed%20on%20a%20vintage%20wooden%20cart%20in%20a%20cobblestone%20alley%20in%20golden%20hour%2C%20tuscan%20village%20backdrop%2C%20warm%20ochre%20and%20sienna%20tones%2C%20italian%20summer%20aesthetic%2C%20travel%20fashion%20editorial%20photography%20with%20cinematic%20atmosphere&width=800&height=600&seq=cat-bags-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 12,
    name: 'Belts',
    nameIt: 'Cinture',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fine%20leather%20belts%20coiled%20elegantly%20on%20a%20dark%20slate%20surface%20with%20brass%20buckle%20reflections%2C%20dramatic%20top%20down%20lighting%20creating%20strong%20shadows%2C%20luxury%20product%20photography%2C%20cognac%20leather%20and%20gunmetal%20tones%2C%20sophisticated%20minimal%20composition%20with%20art%20gallery%20feel&width=800&height=600&seq=cat-belts-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 13,
    name: 'Perfumes',
    nameIt: 'Profumi',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20perfume%20bottles%20with%20golden%20caps%20on%20a%20mirrored%20tray%20surrounded%20by%20fresh%20citrus%20slices%20and%20jasmine%20flowers%2C%20bright%20natural%20window%20light%2C%20french%20boudoir%20aesthetic%2C%20sparkling%20reflections%20and%20soft%20romantic%20atmosphere%2C%20luxury%20fragrance%20editorial%20photography&width=800&height=600&seq=cat-perfumes-v2&orientation=landscape',
    isPopular: false,
  },
  {
    id: 14,
    name: 'Other Stuff',
    nameIt: 'Altro',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20fashion%20accessories%20including%20sunglasses%20scarves%20and%20small%20leather%20goods%20arranged%20on%20a%20vintage%20map%20with%20coffee%20cup%2C%20creative%20studio%20loft%20aesthetic%2C%20warm%20ambient%20morning%20light%2C%20travel%20and%20discovery%20theme%2C%20organized%20chaos%20composition%20with%20rich%20textures&width=800&height=600&seq=cat-other-v2&orientation=landscape',
    isPopular: false,
  },
];

export const popularCategories = categories.filter(c => c.isPopular);
export const otherCategories = categories.filter(c => !c.isPopular);